import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Checkbox, Form, Label } from 'semantic-ui-react'
import axios from 'axios';
import './style.css'

export default function Create() {
	
	const navigate  = useNavigate();
		
	const [maticnibrojlovca, setMaticniBrojLovca] = useState('');
	const [ime, setIme] = useState('');
	const [prezime, setPrezime] = useState('');
	const [adresa, setAdresa] = useState('');
	const [telefon, setTelefon] = useState('');
	const [lovackodrustvo, setLovackoDrustvo] = useState('');
	const [brojlovackodrustvo, setBrojLovackoDrustvo] = useState('');
    const [datumpolaganja, setDatumLovackogIspita] = useState('');
    const [vrstaclanstva, setVrstaClanstva] = useState('');
	const [photo, setPhoto] = useState('');
	const [lovackilist, setLovackiList] = useState(false);
	
	const postData = () => {
        console.log(maticnibrojlovca);
        console.log(ime);
        console.log(prezime);
		
		axios.post(`http://89.46.196.228:3000/api/hunters`,
			{
				"maticnibrojlovca": maticnibrojlovca,
				"ime": ime,
				"prezime": prezime,
				"adresa": adresa,
				"telefon": telefon,
				"lovackodrustvo": lovackodrustvo,
				"brojlovackodrustvo": brojlovackodrustvo,
				"datumpolaganja": datumpolaganja,
				"vrstaclanstva": vrstaclanstva,
				"photo": photo,
				"lovackilist": lovackilist,
			}
			).then(() => {
            navigate('/SLOBiHClanovi/read')
        })
	}
		
    return (
	    <div className="main">
        <div>
            <Form className="create-form">
				<Form.Field>
                    <Label>Maticni broj</Label>
                    <input placeholder='Matični broj' onChange={(e) => setMaticniBrojLovca(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Ime</Label>
                    <input placeholder='Ime' onChange={(e) => setIme(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Prezime</Label>
                    <input placeholder='Prezime' onChange={(e) => setPrezime(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Adresa</Label>
                    <input placeholder='Adresa' onChange={(e) => setAdresa(e.target.value)}/>
                </Form.Field>
				
			    <Form.Field>
                    <Label>Telefon</Label>
                    <input placeholder='Telefon' onChange={(e) => setTelefon(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Lovačko društvo</Label>
                    <input placeholder='Lovačko društvo' onChange={(e) => setLovackoDrustvo(e.target.value)}/>
                </Form.Field>
				
			    <Form.Field>
                    <Label>Datum lovačkog ispita</Label>
                    <input placeholder='Datum lovačkog ispita' onChange={(e) => setDatumLovackogIspita(e.target.value)}/>
                </Form.Field>
				
                <Form.Field>
                    <Label>Vrsta članstva</Label>
                    <input placeholder='Vrsta članstva' onChange={(e) => setVrstaClanstva(e.target.value)}/>
                </Form.Field>
				
                <Form.Field>
                    <Checkbox label='Lovački list' onChange={(e) => setLovackiList(!lovackilist)}/>
                </Form.Field>
                <Button onClick={postData} type='submit'>Submit</Button>
            </Form>
        </div>
		</div>
    )
}